import React from 'react'
import { useMedia } from 'sb-hooks'
import { FormattedMessage } from 'sb-react-intl'

import ActionButtons from '../ActionButtons/ActionButtons'

import messages from './messages'
import s from './Helpful.scss'


const Helpful = (props) => {
  const {
    id,
    isUseful, likeCount, dislikeCount,
    isReplyFormShown, isReplyButtonVisible,
    isHelpfulButtonsActive,
    onVote, onReplyFormToggle,
    dataTestIds,
  } = props

  const { isMobile } = useMedia()

  return (
    <div className={s.helpful}>
      {
        isHelpfulButtonsActive && (
          <div className={s.helpfulText}>
            <FormattedMessage {...(isMobile ? messages.helpful : messages.helpfulLong)} />
          </div>
        )
      }
      <ActionButtons
        id={id}
        isUseful={isUseful}
        likeCount={likeCount}
        dislikeCount={dislikeCount}
        onVote={onVote}
        onReplyFormToggle={onReplyFormToggle}
        replyButtonActive={isReplyFormShown}
        isReplyButtonVisible={isReplyButtonVisible}
        isHelpfulButtonsActive={isHelpfulButtonsActive}
        dataTestIds={dataTestIds}
      />
    </div>
  )
}


export default Helpful
